import AiChatConfig from "@client/content/modules/AiChat/config.json";
import AiChatDefinitions from "@client/content/modules/AiChat/definitions.json";

export const AiChat = {
  config: AiChatConfig,
  definitions: AiChatDefinitions
};

import AudioConfig from "@client/content/modules/Audio/config.json";
import AudioDefinitions from "@client/content/modules/Audio/definitions.json";

export const Audio = {
  config: AudioConfig,
  definitions: AudioDefinitions
};

import BlogDetailCommentsConfig from "@client/content/modules/BlogDetailComments/config.json";
import BlogDetailCommentsDefinitions from "@client/content/modules/BlogDetailComments/definitions.json";

export const BlogDetailComments = {
  config: BlogDetailCommentsConfig,
  definitions: BlogDetailCommentsDefinitions
};

import BlogDetailContentConfig from "@client/content/modules/BlogDetailContent/config.json";
import BlogDetailContentDefinitions from "@client/content/modules/BlogDetailContent/definitions.json";

export const BlogDetailContent = {
  config: BlogDetailContentConfig,
  definitions: BlogDetailContentDefinitions
};

import BlogDetailHeaderConfig from "@client/content/modules/BlogDetailHeader/config.json";
import BlogDetailHeaderDefinitions from "@client/content/modules/BlogDetailHeader/definitions.json";

export const BlogDetailHeader = {
  config: BlogDetailHeaderConfig,
  definitions: BlogDetailHeaderDefinitions
};

import BlogListConfig from "@client/content/modules/BlogList/config.json";
import BlogListDefinitions from "@client/content/modules/BlogList/definitions.json";

export const BlogList = {
  config: BlogListConfig,
  definitions: BlogListDefinitions
};

import ButtonConfig from "@client/content/modules/Button/config.json";
import ButtonDefinitions from "@client/content/modules/Button/definitions.json";

export const Button = {
  config: ButtonConfig,
  definitions: ButtonDefinitions
};

import CartConfig from "@client/content/modules/Cart/config.json";
import CartDefinitions from "@client/content/modules/Cart/definitions.json";

export const Cart = {
  config: CartConfig,
  definitions: CartDefinitions
};

import CheckoutConfig from "@client/content/modules/Checkout/config.json";
import CheckoutDefinitions from "@client/content/modules/Checkout/definitions.json";

export const Checkout = {
  config: CheckoutConfig,
  definitions: CheckoutDefinitions
};

import CheckoutButtonConfig from "@client/content/modules/CheckoutButton/config.json";
import CheckoutButtonDefinitions from "@client/content/modules/CheckoutButton/definitions.json";

export const CheckoutButton = {
  config: CheckoutButtonConfig,
  definitions: CheckoutButtonDefinitions
};

import ContactFormConfig from "@client/content/modules/ContactForm/config.json";
import ContactFormDefinitions from "@client/content/modules/ContactForm/definitions.json";

export const ContactForm = {
  config: ContactFormConfig,
  definitions: ContactFormDefinitions
};

import CountdownConfig from "@client/content/modules/Countdown/config.json";
import CountdownDefinitions from "@client/content/modules/Countdown/definitions.json";

export const Countdown = {
  config: CountdownConfig,
  definitions: CountdownDefinitions
};

import CountdownTimersConfig from "@client/content/modules/CountdownTimers/config.json";
import CountdownTimersDefinitions from "@client/content/modules/CountdownTimers/definitions.json";

export const CountdownTimers = {
  config: CountdownTimersConfig,
  definitions: CountdownTimersDefinitions
};

import CounterConfig from "@client/content/modules/Counter/config.json";
import CounterDefinitions from "@client/content/modules/Counter/definitions.json";

export const Counter = {
  config: CounterConfig,
  definitions: CounterDefinitions
};

import CourseDetailConfig from "@client/content/modules/CourseDetail/config.json";
import CourseDetailDefinitions from "@client/content/modules/CourseDetail/definitions.json";

export const CourseDetail = {
  config: CourseDetailConfig,
  definitions: CourseDetailDefinitions
};

import CourseListConfig from "@client/content/modules/CourseList/config.json";
import CourseListDefinitions from "@client/content/modules/CourseList/definitions.json";

export const CourseList = {
  config: CourseListConfig,
  definitions: CourseListDefinitions
};

import CourseProgressConfig from "@client/content/modules/CourseProgress/config.json";
import CourseProgressDefinitions from "@client/content/modules/CourseProgress/definitions.json";

export const CourseProgress = {
  config: CourseProgressConfig,
  definitions: CourseProgressDefinitions
};

import EventsConfig from "@client/content/modules/Events/config.json";
import EventsDefinitions from "@client/content/modules/Events/definitions.json";

export const Events = {
  config: EventsConfig,
  definitions: EventsDefinitions
};

import FacebookConfig from "@client/content/modules/Facebook/config.json";
import FacebookDefinitions from "@client/content/modules/Facebook/definitions.json";

export const Facebook = {
  config: FacebookConfig,
  definitions: FacebookDefinitions
};

import ForgotPasswordConfig from "@client/content/modules/ForgotPassword/config.json";
import ForgotPasswordDefinitions from "@client/content/modules/ForgotPassword/definitions.json";

export const ForgotPassword = {
  config: ForgotPasswordConfig,
  definitions: ForgotPasswordDefinitions
};

import FormConfig from "@client/content/modules/Form/config.json";
import FormDefinitions from "@client/content/modules/Form/definitions.json";

export const Form = {
  config: FormConfig,
  definitions: FormDefinitions
};

import ForumsConfig from "@client/content/modules/Forums/config.json";
import ForumsDefinitions from "@client/content/modules/Forums/definitions.json";

export const Forums = {
  config: ForumsConfig,
  definitions: ForumsDefinitions
};

import HTMLConfig from "@client/content/modules/HTML/config.json";
import HTMLDefinitions from "@client/content/modules/HTML/definitions.json";

export const HTML = {
  config: HTMLConfig,
  definitions: HTMLDefinitions
};

import IconConfig from "@client/content/modules/Icon/config.json";
import IconDefinitions from "@client/content/modules/Icon/definitions.json";

export const Icon = {
  config: IconConfig,
  definitions: IconDefinitions
};

import IconBoxesConfig from "@client/content/modules/IconBoxes/config.json";
import IconBoxesDefinitions from "@client/content/modules/IconBoxes/definitions.json";

export const IconBoxes = {
  config: IconBoxesConfig,
  definitions: IconBoxesDefinitions
};

import ImageConfig from "@client/content/modules/Image/config.json";
import ImageDefinitions from "@client/content/modules/Image/definitions.json";

export const Image = {
  config: ImageConfig,
  definitions: ImageDefinitions
};

import ImageGalleryConfig from "@client/content/modules/ImageGallery/config.json";
import ImageGalleryDefinitions from "@client/content/modules/ImageGallery/definitions.json";

export const ImageGallery = {
  config: ImageGalleryConfig,
  definitions: ImageGalleryDefinitions
};

import InstagramConfig from "@client/content/modules/Instagram/config.json";
import InstagramDefinitions from "@client/content/modules/Instagram/definitions.json";

export const Instagram = {
  config: InstagramConfig,
  definitions: InstagramDefinitions
};

import KnowledgeBaseConfig from "@client/content/modules/KnowledgeBase/config.json";
import KnowledgeBaseDefinitions from "@client/content/modules/KnowledgeBase/definitions.json";

export const KnowledgeBase = {
  config: KnowledgeBaseConfig,
  definitions: KnowledgeBaseDefinitions
};

import KpiConfig from "@client/content/modules/Kpi/config.json";
import KpiDefinitions from "@client/content/modules/Kpi/definitions.json";

export const Kpi = {
  config: KpiConfig,
  definitions: KpiDefinitions
};

import LeaderboardConfig from "@client/content/modules/Leaderboard/config.json";
import LeaderboardDefinitions from "@client/content/modules/Leaderboard/definitions.json";

export const Leaderboard = {
  config: LeaderboardConfig,
  definitions: LeaderboardDefinitions
};

import ListsConfig from "@client/content/modules/Lists/config.json";
import ListsDefinitions from "@client/content/modules/Lists/definitions.json";

export const Lists = {
  config: ListsConfig,
  definitions: ListsDefinitions
};

import LoginFormConfig from "@client/content/modules/LoginForm/config.json";
import LoginFormDefinitions from "@client/content/modules/LoginForm/definitions.json";

export const LoginForm = {
  config: LoginFormConfig,
  definitions: LoginFormDefinitions
};

import MapsConfig from "@client/content/modules/Maps/config.json";
import MapsDefinitions from "@client/content/modules/Maps/definitions.json";

export const Maps = {
  config: MapsConfig,
  definitions: MapsDefinitions
};

import MemberAffiliateConfig from "@client/content/modules/MemberAffiliate/config.json";
import MemberAffiliateDefinitions from "@client/content/modules/MemberAffiliate/definitions.json";

export const MemberAffiliate = {
  config: MemberAffiliateConfig,
  definitions: MemberAffiliateDefinitions
};

import MemberAffiliateDashboardConfig from "@client/content/modules/MemberAffiliateDashboard/config.json";
import MemberAffiliateDashboardDefinitions from "@client/content/modules/MemberAffiliateDashboard/definitions.json";
import MemberAffiliateDashboardStructure from "@client/content/modules/MemberAffiliateDashboard/structure.json";

export const MemberAffiliateDashboard = {
  config: MemberAffiliateDashboardConfig,
  definitions: MemberAffiliateDashboardDefinitions,
  structure: MemberAffiliateDashboardStructure
};

import MemberDownloadsConfig from "@client/content/modules/MemberDownloads/config.json";
import MemberDownloadsDefinitions from "@client/content/modules/MemberDownloads/definitions.json";

export const MemberDownloads = {
  config: MemberDownloadsConfig,
  definitions: MemberDownloadsDefinitions
};

import MemberHelpdeskConfig from "@client/content/modules/MemberHelpdesk/config.json";
import MemberHelpdeskDefinitions from "@client/content/modules/MemberHelpdesk/definitions.json";

export const MemberHelpdesk = {
  config: MemberHelpdeskConfig,
  definitions: MemberHelpdeskDefinitions
};

import MemberOrdersConfig from "@client/content/modules/MemberOrders/config.json";
import MemberOrdersDefinitions from "@client/content/modules/MemberOrders/definitions.json";

export const MemberOrders = {
  config: MemberOrdersConfig,
  definitions: MemberOrdersDefinitions
};

import MemberPayoutMethodsConfig from "@client/content/modules/MemberPayoutMethods/config.json";
import MemberPayoutMethodsDefinitions from "@client/content/modules/MemberPayoutMethods/definitions.json";

export const MemberPayoutMethods = {
  config: MemberPayoutMethodsConfig,
  definitions: MemberPayoutMethodsDefinitions
};

import MemberProfileConfig from "@client/content/modules/MemberProfile/config.json";
import MemberProfileDefinitions from "@client/content/modules/MemberProfile/definitions.json";

export const MemberProfile = {
  config: MemberProfileConfig,
  definitions: MemberProfileDefinitions
};

import MemberRecurringOrdersConfig from "@client/content/modules/MemberRecurringOrders/config.json";
import MemberRecurringOrdersDefinitions from "@client/content/modules/MemberRecurringOrders/definitions.json";

export const MemberRecurringOrders = {
  config: MemberRecurringOrdersConfig,
  definitions: MemberRecurringOrdersDefinitions
};

import MemberSurveyConfig from "@client/content/modules/MemberSurvey/config.json";
import MemberSurveyDefinitions from "@client/content/modules/MemberSurvey/definitions.json";

export const MemberSurvey = {
  config: MemberSurveyConfig,
  definitions: MemberSurveyDefinitions
};

import MemberTicketDetailConfig from "@client/content/modules/MemberTicketDetail/config.json";
import MemberTicketDetailDefinitions from "@client/content/modules/MemberTicketDetail/definitions.json";

export const MemberTicketDetail = {
  config: MemberTicketDetailConfig,
  definitions: MemberTicketDetailDefinitions
};

import MemberVouchersConfig from "@client/content/modules/MemberVouchers/config.json";
import MemberVouchersDefinitions from "@client/content/modules/MemberVouchers/definitions.json";

export const MemberVouchers = {
  config: MemberVouchersConfig,
  definitions: MemberVouchersDefinitions
};

import MemberWalletsConfig from "@client/content/modules/MemberWallets/config.json";
import MemberWalletsDefinitions from "@client/content/modules/MemberWallets/definitions.json";

export const MemberWallets = {
  config: MemberWalletsConfig,
  definitions: MemberWalletsDefinitions
};

import MiniProfileConfig from "@client/content/modules/MiniProfile/config.json";
import MiniProfileDefinitions from "@client/content/modules/MiniProfile/definitions.json";

export const MiniProfile = {
  config: MiniProfileConfig,
  definitions: MiniProfileDefinitions
};

import NetworkPlacementConfig from "@client/content/modules/NetworkPlacement/config.json";
import NetworkPlacementDefinitions from "@client/content/modules/NetworkPlacement/definitions.json";

export const NetworkPlacement = {
  config: NetworkPlacementConfig,
  definitions: NetworkPlacementDefinitions
};

import OptInFormV2Config from "@client/content/modules/OptInFormV2/config.json";
import OptInFormV2Definitions from "@client/content/modules/OptInFormV2/definitions.json";

export const OptInFormV2 = {
  config: OptInFormV2Config,
  definitions: OptInFormV2Definitions
};

import OrderConfirmationConfig from "@client/content/modules/OrderConfirmation/config.json";
import OrderConfirmationDefinitions from "@client/content/modules/OrderConfirmation/definitions.json";

export const OrderConfirmation = {
  config: OrderConfirmationConfig,
  definitions: OrderConfirmationDefinitions
};

import OrderDetailConfig from "@client/content/modules/OrderDetail/config.json";
import OrderDetailDefinitions from "@client/content/modules/OrderDetail/definitions.json";

export const OrderDetail = {
  config: OrderDetailConfig,
  definitions: OrderDetailDefinitions
};

import OrderTimelineConfig from "@client/content/modules/OrderTimeline/config.json";
import OrderTimelineDefinitions from "@client/content/modules/OrderTimeline/definitions.json";

export const OrderTimeline = {
  config: OrderTimelineConfig,
  definitions: OrderTimelineDefinitions
};

import PackagePricingConfig from "@client/content/modules/PackagePricing/config.json";
import PackagePricingDefinitions from "@client/content/modules/PackagePricing/definitions.json";

export const PackagePricing = {
  config: PackagePricingConfig,
  definitions: PackagePricingDefinitions
};

import PieChartConfig from "@client/content/modules/PieChart/config.json";
import PieChartDefinitions from "@client/content/modules/PieChart/definitions.json";

export const PieChart = {
  config: PieChartConfig,
  definitions: PieChartDefinitions
};

import PortfolioGalleryConfig from "@client/content/modules/PortfolioGallery/config.json";
import PortfolioGalleryDefinitions from "@client/content/modules/PortfolioGallery/definitions.json";

export const PortfolioGallery = {
  config: PortfolioGalleryConfig,
  definitions: PortfolioGalleryDefinitions
};

import ProductDetailConfig from "@client/content/modules/ProductDetail/config.json";
import ProductDetailDefinitions from "@client/content/modules/ProductDetail/definitions.json";

export const ProductDetail = {
  config: ProductDetailConfig,
  definitions: ProductDetailDefinitions
};

import ProductListConfig from "@client/content/modules/ProductList/config.json";
import ProductListDefinitions from "@client/content/modules/ProductList/definitions.json";

export const ProductList = {
  config: ProductListConfig,
  definitions: ProductListDefinitions
};

import ProgressBarConfig from "@client/content/modules/ProgressBar/config.json";
import ProgressBarDefinitions from "@client/content/modules/ProgressBar/definitions.json";

export const ProgressBar = {
  config: ProgressBarConfig,
  definitions: ProgressBarDefinitions
};

import PurchaseConfig from "@client/content/modules/Purchase/config.json";
import PurchaseDefinitions from "@client/content/modules/Purchase/definitions.json";

export const Purchase = {
  config: PurchaseConfig,
  definitions: PurchaseDefinitions
};

import RegisterConfig from "@client/content/modules/Register/config.json";
import RegisterDefinitions from "@client/content/modules/Register/definitions.json";

export const Register = {
  config: RegisterConfig,
  definitions: RegisterDefinitions
};

import ReportConfig from "@client/content/modules/Report/config.json";
import ReportDefinitions from "@client/content/modules/Report/definitions.json";

export const Report = {
  config: ReportConfig,
  definitions: ReportDefinitions
};

import SearchConfig from "@client/content/modules/Search/config.json";
import SearchDefinitions from "@client/content/modules/Search/definitions.json";

export const Search = {
  config: SearchConfig,
  definitions: SearchDefinitions
};

import SeparatorsConfig from "@client/content/modules/Separators/config.json";
import SeparatorsDefinitions from "@client/content/modules/Separators/definitions.json";

export const Separators = {
  config: SeparatorsConfig,
  definitions: SeparatorsDefinitions
};

import SocialIconsConfig from "@client/content/modules/SocialIcons/config.json";
import SocialIconsDefinitions from "@client/content/modules/SocialIcons/definitions.json";

export const SocialIcons = {
  config: SocialIconsConfig,
  definitions: SocialIconsDefinitions
};

import SpacerConfig from "@client/content/modules/Spacer/config.json";
import SpacerDefinitions from "@client/content/modules/Spacer/definitions.json";

export const Spacer = {
  config: SpacerConfig,
  definitions: SpacerDefinitions
};

import SystemRedirectConfig from "@client/content/modules/SystemRedirect/config.json";
import SystemRedirectDefinitions from "@client/content/modules/SystemRedirect/definitions.json";

export const SystemRedirect = {
  config: SystemRedirectConfig,
  definitions: SystemRedirectDefinitions
};

import TextHTMLConfig from "@client/content/modules/TextHTML/config.json";
import TextHTMLDefinitions from "@client/content/modules/TextHTML/definitions.json";

export const TextHTML = {
  config: TextHTMLConfig,
  definitions: TextHTMLDefinitions
};

import TitleConfig from "@client/content/modules/Title/config.json";
import TitleDefinitions from "@client/content/modules/Title/definitions.json";

export const Title = {
  config: TitleConfig,
  definitions: TitleDefinitions
};

import TwitterConfig from "@client/content/modules/Twitter/config.json";
import TwitterDefinitions from "@client/content/modules/Twitter/definitions.json";

export const Twitter = {
  config: TwitterConfig,
  definitions: TwitterDefinitions
};

import UnsubscribeConfig from "@client/content/modules/Unsubscribe/config.json";
import UnsubscribeDefinitions from "@client/content/modules/Unsubscribe/definitions.json";

export const Unsubscribe = {
  config: UnsubscribeConfig,
  definitions: UnsubscribeDefinitions
};

import VerificationConfig from "@client/content/modules/Verification/config.json";
import VerificationDefinitions from "@client/content/modules/Verification/definitions.json";

export const Verification = {
  config: VerificationConfig,
  definitions: VerificationDefinitions
};

import VideoConfig from "@client/content/modules/Video/config.json";
import VideoDefinitions from "@client/content/modules/Video/definitions.json";

export const Video = {
  config: VideoConfig,
  definitions: VideoDefinitions
};
